import {useAuth} from "@hooks/useAuth.tsx";
import {PropsWithChildren, ReactElement} from "react";
import {Button, Center, Paper, Stack, Text, Title} from "@mantine/core";
import {PermissaoType} from "../../models/PermissaoEnum.ts";
import {IconLock} from "@tabler/icons-react";
import {useNavigate} from "react-router";

export type RequiredPermission = {
	modulo: PermissaoType['modulo'],
	tipo?: PermissaoType['tipo'],
	acao?: string
}

export function Permissionable(props?: PropsWithChildren<{
	permissions?: RequiredPermission[],
	ForbiddenElement?: ReactElement
}>) {
	const {hasPermission} = useAuth()
	const navigate = useNavigate()

	if ((props?.permissions?.length ?? 0) > 0) {
		const isAuthorized = hasPermission(props.permissions as any);

		if (!isAuthorized) {
			return props?.ForbiddenElement ?? (
				<Center py="xl" px="md" style={{width: "100%"}}>
					<Paper withBorder shadow="md" p="xl" radius="md" style={{maxWidth: 480, width: "100%"}}>
						<Stack gap="md" align="center" style={{textAlign: "center"}}>
							<IconLock size={52} color="#f59f00" />
							<Title order={3}>Acesso não autorizado</Title>
							<Text size="sm" c="dimmed">
								Você não possui permissão para visualizar este conteúdo.
							</Text>
							{props?.permissions && props.permissions.length > 0 && (
								<Stack gap={4}>
									<Text size="xs" fw={600} c="dimmed">Permissões necessárias:</Text>
									<Text size="xs" c="dimmed">
										{props.permissions.map(perm => `${perm?.modulo}_${perm?.acao ?? '*'}`).join(', ')}
									</Text>
								</Stack>
							)}
							<Button variant="filled" onClick={() => navigate(-1)} mt="xs">
								Voltar
							</Button>
						</Stack>
					</Paper>
				</Center>
			);
		}
	}

	return (<>{props?.children ?? <></>}</>)
}
